var map = {
	"./auditlog.cattle.io.auditpolicy": 11891,
	"./auditlog.cattle.io.auditpolicy.vue": 11891,
	"./catalog.cattle.io.app": 75459,
	"./catalog.cattle.io.app.vue": 75459,
	"./catalog.cattle.io.clusterrepo": 58915,
	"./catalog.cattle.io.clusterrepo.vue": 58915,
	"./compliance.cattle.io.clusterscan": 94875,
	"./compliance.cattle.io.clusterscan.vue": 94875,
	"./ext.cattle.io.kubeconfig": 34637,
	"./ext.cattle.io.kubeconfig.vue": 34637,
	"./fleet.cattle.io.bundle": 7233,
	"./fleet.cattle.io.bundle.vue": 7233,
	"./fleet.cattle.io.cluster": 75339,
	"./fleet.cattle.io.cluster.vue": 75339,
	"./fleet.cattle.io.clustergroup": 31423,
	"./fleet.cattle.io.clustergroup.vue": 31423,
	"./fleet.cattle.io.clusterregistrationtoken": 74210,
	"./fleet.cattle.io.clusterregistrationtoken.vue": 74210,
	"./fleet.cattle.io.gitrepo": 10289,
	"./fleet.cattle.io.gitrepo.vue": 10289,
	"./fleet.cattle.io.helmop": 40915,
	"./fleet.cattle.io.helmop.vue": 40915,
	"./group.principal": 24969,
	"./group.principal.vue": 24969,
	"./harvesterhci.io.management.cluster": 73231,
	"./harvesterhci.io.management.cluster.vue": 73231,
	"./helm.cattle.io.projecthelmchart": 16521,
	"./helm.cattle.io.projecthelmchart.vue": 16521,
	"./logging.banzaicloud.io.clusterflow": 44782,
	"./logging.banzaicloud.io.clusterflow.vue": 44782,
	"./logging.banzaicloud.io.flow": 10714,
	"./logging.banzaicloud.io.flow.vue": 10714,
	"./management.cattle.io.cluster": 38567,
	"./management.cattle.io.cluster.vue": 38567,
	"./management.cattle.io.feature": 70565,
	"./management.cattle.io.feature.vue": 70565,
	"./management.cattle.io.fleetworkspace": 76339,
	"./management.cattle.io.fleetworkspace.vue": 76339,
	"./management.cattle.io.oidcclient": 14433,
	"./management.cattle.io.oidcclient.vue": 14433,
	"./management.cattle.io.podsecurityadmissionconfigurationtemplate": 22483,
	"./management.cattle.io.podsecurityadmissionconfigurationtemplate.vue": 22483,
	"./management.cattle.io.setting": 69385,
	"./management.cattle.io.setting.vue": 69385,
	"./management.cattle.io.user": 90329,
	"./management.cattle.io.user.vue": 90329,
	"./monitoring.coreos.com.alertmanagerconfig": 79207,
	"./monitoring.coreos.com.alertmanagerconfig.vue": 79207,
	"./namespace": 63402,
	"./namespace.vue": 63402,
	"./networking.k8s.io.ingress": 23158,
	"./networking.k8s.io.ingress.vue": 23158,
	"./node": 67607,
	"./node.vue": 67607,
	"./persistentvolume": 62891,
	"./persistentvolume.vue": 62891,
	"./persistentvolumeclaim": 83946,
	"./persistentvolumeclaim.vue": 83946,
	"./projectsecret": 31176,
	"./projectsecret.vue": 31176,
	"./provisioning.cattle.io.cluster": 49578,
	"./provisioning.cattle.io.cluster.vue": 49578,
	"./rbac.authorization.k8s.io.clusterrolebinding": 30757,
	"./rbac.authorization.k8s.io.clusterrolebinding.vue": 30757,
	"./secret": 86103,
	"./secret.vue": 86103,
	"./service": 51080,
	"./service.vue": 51080,
	"./ui.cattle.io.navlink": 32362,
	"./ui.cattle.io.navlink.vue": 32362,
	"./workload": 72327,
	"./workload.vue": 72327
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 78967;
module.exports = webpackAsyncContext;